import { render, staticRenderFns } from "./CameraPage.vue?vue&type=template&id=4505ecad&"
import script from "./CameraPage.vue?vue&type=script&lang=js&"
export * from "./CameraPage.vue?vue&type=script&lang=js&"
import style0 from "./CameraPage.vue?vue&type=style&index=0&id=4505ecad&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports